import React from 'react';
import { getRandomElementWithoutRepeats } from '../utils/madLibUtils';
import templates from '../data/templates';
import './CoverPage.css';

const CoverPage = ({ onGenerate, onPrintMode }) => {
    const handleGenerate = () => {
        const template = getRandomElementWithoutRepeats(templates);
        onGenerate(template);
    };

    const handlePrintMode = () => {
        const template = getRandomElementWithoutRepeats(templates);
        onPrintMode(template);
    };

    return (
        <div className="cover-page-container">
            <div className="cover-content">
                <h1>MAD FILLS</h1>
                <p className="tagline">The World's Greatest Word Game!</p>
                <p className="subtitle">Hours of Hilarious Fun!</p>
                
                <div className="instructions-box">
                    <p><strong>CHOOSE YOUR MODE:</strong></p>
                    <p><strong>PLAY MODE:</strong> Fill in words on screen and read your story</p>
                    <p><strong>PRINT MODE:</strong> Get a 2-page PDF to print and play offline</p>
                </div>

                <div className="button-container">
                    <button onClick={handleGenerate} className="generate-button play-button">
                        🎮 PLAY MODE
                    </button>
                    
                    <button onClick={handlePrintMode} className="generate-button print-button">
                        🖨️ PRINT MODE
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CoverPage;